import { service } from '@ember/service';
import Route from '@ember/routing/route';
import {
  loadSelectedSchool,
  saveCoursesDate,
} from 'tio-common/utils/tuition-assistance/application-new-route';
import { getSingleValueForTasField } from 'tio-common/utils/tuition-assistance/fields';
import type { IntlService } from 'ember-intl';
import type RouterService from '@ember/routing/router';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';
import type TasApplicationModel from 'tio-common/models/tas-application';

export default class AuthenticatedTasApplicationsTypeFourGuidedNewRoute extends Route {
  @service declare store: StoreService;
  @service declare router: RouterService;
  @service declare intl: IntlService;

  includes = [
    'tas-courses',
    'tas-courses.tas-assets.attachments',
    'tas-courses.tas-assets.asset-summary',
    'tas-program-instance',
    'tas-program-instance.tas-program-template.tas-groups',
    'tas-program-instance.tas-program-template.conditions.public-assets',
    'tas-program-instance.tas-program-template.tas-field-options',
    'tas-program-instance.employee.person',
    'tas-program-instance.employee.tas-participant',
    'tas-program-instance.employee.company',
    'tas-program-instance.employee.pcs-card-holders',
    'tas-program-instance.tas-program-template.company.company-setting',
    'tas-assets.attachments',
    'tas-assets.asset-summary',
    'tas-assistances',
    'comments',
    'tags',
  ];

  queryParams = {
    date: {
      refreshModel: false,
    },
  };

  async model({ tas_application_id, date = '' }: { tas_application_id: string; date?: string }) {
    const application = await this.store.findRecord<TasApplicationModel>(
      'tas-application',
      tas_application_id,
      {
        include: this.includes.join(','),
        reload: true,
      }
    );
    const programInstance = application.tasProgramInstance;

    if (date) {
      const lockStatus: string = getSingleValueForTasField(
        'LOCK_EMPLOYEE_STATUS_BASED_ON',
        programInstance.tasProgramTemplate.fields
      );
      if (saveCoursesDate(date, application, lockStatus)) {
        try {
          await application.save();
        } catch (error) {
          console.error('Failed to save application, instance, or course:', error);
          application.rollbackAttributes();
        }
      }
    }

    const selectedSchool = await loadSelectedSchool(programInstance, this.store);

    try {
      await application.loadHistory();
    } catch (e) {
      // History is non-critical — don't block the route
      console.error('Error loading application history', e);
    }

    return {
      application,
      programInstance,
      selectedSchool,
    };
  }
}
